import { render } from "./Toast.vue?vue&type=template&id=8af3693a"
const script = {}

import "./Toast.vue?vue&type=style&index=0&id=8af3693a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__